(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiara-sanctuary"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSanctuary(root) {
    if (!root || root.dataset.ksReady === 'true') return;
    root.dataset.ksReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const parallaxEls = Array.from(root.querySelectorAll('.ks-parallax'));
    const journey = root.querySelector('[data-ks-journey]');
    const steps = journey ? Array.from(journey.querySelectorAll('.ks-step')) : [];
    const brings = root.querySelector('[data-ks-brings]');
    const phrases = brings ? Array.from(brings.querySelectorAll('.ks-phrase')) : [];

    function update() {
      if (!reduceMotion) {
        parallaxEls.forEach((el) => {
          const speed = Number(el.dataset.speed || 0);
          const parent = el.closest('.ks-scene');
          if (!parent) return;
          const rect = parent.getBoundingClientRect();
          const local = -rect.top;
          el.style.transform = 'translate3d(0,' + (local * speed) + 'px,0) scale(1.05)';
        });
      }

      if (journey && steps.length) {
        const rect = journey.getBoundingClientRect();
        const denom = Math.max(1, rect.height - window.innerHeight);
        const progress = Math.min(0.999, Math.max(0, -rect.top / denom));
        const active = Math.min(steps.length - 1, Math.floor(progress * steps.length));
        steps.forEach((step, i) => step.classList.toggle('is-active', i === active));
      }

      if (brings && phrases.length) {
        const rect = brings.getBoundingClientRect();
        const denom = Math.max(1, rect.height - window.innerHeight);
        const progress = Math.min(0.999, Math.max(0, -rect.top / denom));
        const active = Math.min(phrases.length - 1, Math.floor(progress * phrases.length));
        phrases.forEach((phrase, i) => phrase.classList.toggle('is-active', i === active));
      }
    }

    let ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-ks-sanctuary]').forEach(initSanctuary);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();

  } catch(e) { console.error(e); }
})();
})();
